import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { pushToDataLayer } from "../utils/gtm";

function ThankYou() {
  const location = useLocation();
  const brochureUrl = location.state?.brochureUrl;
  const brochureName = brochureUrl ? location.state?.brochureName || "brochure.pdf" : null;
  const formId = new URLSearchParams(location.search).get("formId");

  useEffect(() => {
    if (!formId) return;
    const formType = brochureUrl ? "brochure" : "contact";
    const basePayload = {
      form_id: formId,
      form_type: formType,
      page_location: window.location.href,
      page_path: location.pathname + location.search,
    };

    pushToDataLayer("form_submit", basePayload);

    if (brochureUrl) {
      pushToDataLayer("brochure_download", {
        ...basePayload,
        brochure_url: brochureUrl,
        brochure_name: brochureName || "brochure.pdf",
      });
    }
  }, [formId, brochureUrl, brochureName, location.pathname, location.search]);

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8 text-center">
          <h1 className="text-blue fw-bold mb-3">Thank you!</h1>
          <p className="mb-4">
            {brochureUrl
              ? "Your brochure download should start automatically."
              : "Your request has been received. We'll get back to you soon."}
          </p>
          {/* {formId && (
            <p className="text-muted mb-4">
              Reference: {formId}
            </p>
          )} */}
          {brochureUrl && (
            <a
              href={brochureUrl}
              download={brochureName}
              className="btn btn-outline-primary mb-4"
            >
              Download Again
            </a>
          )}
          <Link to="/products" className="btn btn-primary">
            Back to Products
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ThankYou;
